<div @parent class="parent-container">
  <div
    [ngClass]="{ 'mobile-with-overlay': deviceService.isMobile(), 'right-open' : openFromRight, 'with-update':updateOverlayShown}"
    class="sidebar-container" *ngIf="(!mobileOnly && deviceService.isDesktop()) || isDrawerOpen"
    [@drawerOpen]="isDrawerOpen">
    <div class="page-sidebar">
      <div class="drawer-content">
        <div class="flex-list" [ngClass]="{'expanded-drawer': drawerExpanded}">
          <div class="left-icons showfullleft">
            <div class="extra" *ngIf="currentBetreuer">
              <div  class="extra-header betreuer-action" (click)="routerService.navigateMaklerbetreuerDetail(currentBetreuer.personId.toString())">
                <div class="text">{{currentBetreuer.name ? currentBetreuer.name : '-'}}</div>
              </div>
              <div textSmall class="extra-body">
                {{currentBetreuer.betreuerNummer ? 'BetreuerNr. '+currentBetreuer.betreuerNummer : ''}}
                <span class="betreuer-action inline-flex" textSmall (click)="routerService.navigateSettingsBetreuerChange()">
                (
                  <div class="text">Wechseln</div>
                  <mat-icon>launch</mat-icon>
                  )
                </span>
              </div>
            </div>
            <ng-container *ngFor="let group of groupedAndFilteredDrawerItems">
              <div class="menu-inner-container" *ngIf="group.key && group.key.id !== NO_GROUP">
                <div (click)="collapseExpand(group.key)"
                   class="collapseexpand-item list-item">
                  <span class="item-name collapseexpand-header">{{group.key.header}}</span>
                  <mat-icon class="collapseexpand-icon">
                    {{group.key.expanded ? 'expand_less' : 'expand_more'}}
                  </mat-icon>
                </div>
              </div>
              <ng-container *ngIf="group.key && group.key.expanded">
                <ng-container *ngFor="let category of group.value; let i = index">
                  <div class="menu-inner-container" routerLinkActive="current" [@expandCollapse]="true"
                       [ngClass]="{'inside-category':isCategorySidenavVisible(category), 'has-header': group.key && group.key.id !== NO_GROUP}">
                    <div (click)="handleGlobalItemClick(category)" [routerLink]="category.routerUrl"
                       class="dark-bg list-item"  [ngStyle]="getFavoriteCategoryColor(category) && {'background-color':getFavoriteCategoryColor(category)}">
                      <mat-icon matListItemIcon class="item-icon"
                                *ngIf="category.icon">{{category.icon}}</mat-icon>
                      <span class="item-name">{{category.header}}</span>
                      <mat-icon *ngIf="category.devOnly" class="devonly-icon"
                                title="Nur für Entwickler/Tester sichtbar">
                        visibility_off
                      </mat-icon>
                    </div>
                    <div class="subitems"
                         *ngIf="subItems && subItems.length >0 && isCategorySidenavVisible(category)"
                         [@expandCollapse]="subItems && subItems.length >0 && isCategorySidenavVisible(category)">
                      <ng-container *ngFor="let category of subItems">
                        <div class="subitems-clickable-header-container" *ngIf="category.clickableHeader"
                             (click)="handleHeaderItemClick(category.clickableHeader)">
                          <mat-icon *ngIf="category.clickableHeader.icon">{{category.clickableHeader.icon}}</mat-icon>
                          <div textSmall>{{category.clickableHeader.name}}</div>
                        </div>
                        <div class="subitems-header-container" *ngIf="category.header">
                          <mat-icon *ngIf="category.icon">{{category.icon}}</mat-icon>
                          <div textSmall>{{category.header}}</div>
                        </div>
                        <ng-container *ngFor="let item of category.subItems">
                          <div class="sub-item-list">
                            <ng-container *ngIf="(!item.devOnly || isDevMode()) && !item.hidden">
                              <ng-container *appHasRightId="item.right">
                                <div class="sub-item"
                                   [routerLink]="item.dynamicURLPart ? item.dynamicURLPart + item.routerUrl : item.routerUrl"
                                   [queryParams]="item.queryParams"
                                   routerLinkActive="highlighted" [routerLinkActiveOptions]="{exact: true}"
                                   (click)="handleItemClick(item)">
                                  <span class="item-name">{{item.name}}</span>
                                  <mat-icon *ngIf="item.devOnly" class="devonly-icon"
                                            title="Nur für Entwickler/Tester sichtbar">visibility_off
                                  </mat-icon>
                                </div>
                              </ng-container>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="mobile-overlay" *ngIf="isDrawerOpen && deviceService.isMobile()" (click)="isDrawerOpen = false"
     [ngClass]="{'with-update':updateOverlayShown}"></div>
